import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { env } from '../config/runtimeEnv';

const DEFAULT_LANGUAGE = 'en';

// Last resort when a key cannot be resolved (failed namespace fetch, or a
// stale bundle that predates the key). Rendering "Save changes" degrades
// better than leaking the dotted key path into the UI.
function humanizeKey(key: string): string {
  const last = key.split('.').pop() ?? key;
  const spaced = last
    .replace(/[_-]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .trim();
  if (spaced === '') return key;
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

function applyDocumentLanguageAndDirection() {
  document.documentElement.lang = DEFAULT_LANGUAGE;
  document.documentElement.dir = 'ltr';
}

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: DEFAULT_LANGUAGE,
    supportedLngs: [DEFAULT_LANGUAGE, 'he', 'ar'],
    fallbackLng: DEFAULT_LANGUAGE,

    // Start minimal; feature namespaces are lazy-loaded on demand.
    defaultNS: 'common',
    ns: ['common'],

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Locale URLs are stable across deploys, so a gateway or browser cache
      // can pair old strings with new code. The token changes every deploy.
      queryStringParams: { v: env.ASSET_VERSION },
    },

    parseMissingKeyHandler: (key) => humanizeKey(key),

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },
  });

applyDocumentLanguageAndDirection();

export default i18n;
